import { render, staticRenderFns } from "./CardBootstrapCustomBS46.vue?vue&type=template&id=769ad999&scoped=true"
import script from "./CardBootstrapCustomBS46.vue?vue&type=script&lang=js"
export * from "./CardBootstrapCustomBS46.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769ad999",
  null
  
)

export default component.exports